module.exports = __webpack_public_path__ + "static/signature.1.0.0-black-4b113305057738cec7992c0aa4b4b259.png";